import * as Yup from 'yup';

const REQUIRED_TXT = 'This field is required';
const EMAIL_TXT = 'Must be a valid email';
const LINKEDIN_URL_TXT = 'LinkedIn URL must start with "https://www." please copy correct link';

const PASSWORD_VALIDATION_MESSAGE = 'Password must be 8-20 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character without spaces';

export const emailRegExp = /^[a-zA-Z0-9_%+-]+(?:\.[a-zA-Z0-9_%+-]+)*@(?!.*(?:\d{1,3}\.){3}\d{1,3})[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*(?!\.web)[a-zA-Z]{2,}$/;




const passwordValidation = Yup.string()
    .min(8, PASSWORD_VALIDATION_MESSAGE)
    .max(20, PASSWORD_VALIDATION_MESSAGE)
    // .matches(/[a-z]/, PASSWORD_VALIDATION_MESSAGE)
    // .matches(/[A-Z]/, PASSWORD_VALIDATION_MESSAGE)
    .matches(/\d/, PASSWORD_VALIDATION_MESSAGE)
    .matches(/[!@#$%^&*(),.?":{}|<>]/, PASSWORD_VALIDATION_MESSAGE)
    .matches(/^[^\s]+$/, PASSWORD_VALIDATION_MESSAGE)
    .required(REQUIRED_TXT);

const numberOfYearsValidation = Yup.number()
    .typeError('Please enter a valid number')
    .min(1, 'Number must be greater than 0')
    .max(29, 'Number must be less than 30')
    .required(REQUIRED_TXT)

export const SignUpFormSchema = Yup.object({
    email: Yup.string().matches(emailRegExp, EMAIL_TXT).required(REQUIRED_TXT),
    password: passwordValidation,
    passwordRepeated: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required(REQUIRED_TXT),
});

export const LoginFormSchema = Yup.object({
    email: Yup.string().matches(emailRegExp, EMAIL_TXT).required(REQUIRED_TXT),
    password: passwordValidation,
});

export const InitiateResetPasswordSchema = Yup.object({
    email: Yup.string().matches(emailRegExp, EMAIL_TXT).required(REQUIRED_TXT),
});

export const PasswordChangeFormSchema = Yup.object({
    new_password1: Yup.string().required(REQUIRED_TXT),
    new_password2: Yup.string()
        .oneOf([Yup.ref('new_password1'), null], 'Passwords must match')
        .required(REQUIRED_TXT),
});


export const PersonalInformationSchema = Yup.object({
    name: Yup.string().required(REQUIRED_TXT),
    email: Yup.string().matches(emailRegExp, EMAIL_TXT),
    phone: Yup.string(),
    linkedin: Yup.string(),
    address: Yup.string(),
    jobTitle: Yup.string().required(REQUIRED_TXT),
});
export const linkedinFormSchema = Yup.object({
    email: Yup.string().email(EMAIL_TXT).required(REQUIRED_TXT),
    linkedinUrl: Yup.string().required(REQUIRED_TXT).matches(/^https:\/\/www\./, LINKEDIN_URL_TXT),
});

export const FromScratchFormSchema = Yup.object({
    firstName: Yup.string().required(REQUIRED_TXT),
    lastName: Yup.string().required(REQUIRED_TXT),
    email: Yup.string().matches(emailRegExp, EMAIL_TXT).required(REQUIRED_TXT),
    jobTitle: Yup.string().required(REQUIRED_TXT),
});
export const FileUploadFormSchema = Yup.object({
    name: Yup.string().required(REQUIRED_TXT),
    email: Yup.string().matches(emailRegExp, EMAIL_TXT).required(REQUIRED_TXT),
    JobTitle: Yup.string().required(REQUIRED_TXT),
    jobDescription: Yup.string().required(REQUIRED_TXT),
    pdf: Yup.mixed().required(REQUIRED_TXT),
});
export const CoverLetterFormSchema = Yup.object({
    firstName: Yup.string().required(REQUIRED_TXT),
    lastName: Yup.string().required(REQUIRED_TXT),
    email: Yup.string().matches(emailRegExp, EMAIL_TXT).required(REQUIRED_TXT),
    jobTitle: Yup.string().required(REQUIRED_TXT),
    companyName:Yup.string().required(REQUIRED_TXT),
    // languageOptions:Yup.string(),
    yearsOfExperience:Yup.string().required(REQUIRED_TXT)
});

